import { SortableDefinitionsType } from "@/components/@types";
import { Icon } from "@/components/atoms/Icon";
import { Typography } from "@/components/ui/typography";

export function SortChipDefinitionRow({
  sortableDefinition,
}: {
  sortableDefinition: SortableDefinitionsType;
}) {
  return (
    <div
      data-testid={`sort-definition-row-${sortableDefinition.name}`}
      className="flex flex-wrap items-center gap-2 pl-1 min-w-100"
    >
      <div>
        {
          <Icon
            ReactIcon={sortableDefinition.ReactIcon}
            size="sm"
            style={{
              transform: "translateY(1px)",
            }}
          />
        }
      </div>
      <Typography level="body-md">{sortableDefinition.name}</Typography>
      <div className="grow" />
      <Typography
        level="body-xs"
        className="[border-width:1px] [border-style:solid] border-border text-muted-foreground/80 pl-1 pr-1 pb-px text-center rounded"
      >
        {sortableDefinition.type}
      </Typography>
    </div>
  );
}
